// extracted by mini-css-extract-plugin
module.exports = {"share-links":"ShareButtons_share-links__wvNkM","facebook":"ShareButtons_facebook__apF9a","twitter":"ShareButtons_twitter__q93qL"};